import { Redirect } from 'react-router-dom'
import { useEffect, useState } from 'react'
import Home from '../containers/Home'
import { reroutesOnLoad } from '../api/utils'

const ReroutesHome = () => {
  const [authRole, setAuthRole] = useState('')
  const [homePath, setHomePath] = useState('')

  useEffect(() => {
    async function onLoad() {
      const response = await reroutesOnLoad()
      if (response) {
        setAuthRole(response.role)
        setHomePath(response.homePath)
      }
    }
    onLoad()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {
        {
          '': <Home />,
          customer: <Redirect to={homePath} />,
          merchant: <Redirect to={homePath} />,
          admin: <Redirect to={homePath} />,
        }[authRole]
      }
    </>
  )
}

export { ReroutesHome as default }
